import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
declare const Swal;

@Component({
  selector: 'app-edit-geofence',
  templateUrl: './edit-geofence.component.html',
  styleUrls: ['./edit-geofence.component.css']
})
export class EditGeofenceComponent implements OnInit {

  @ViewChild('modalHide') modalHide;


  public editGeofenceForm: FormGroup;
  public editGeofenceFormSubmitted: boolean = false;
  public branchObj = {};
  public branchLocation = {};
  public selectedValueClose = false;
  public locationSuggestions = {};
  public firstLoadLocation: boolean = true;

  primaryMap: any;
  mapSearchDebounceTimeOut = null;
  mapSearchDataLists = [];
  markerId = 'branchLocation';

  public editLocation: boolean = true;
  public locationData = {};
  formSubmit: boolean = false;
  public vehiclelists: any = [];

  public orgID;
  public branchID;
  public updateValues = [];
  public updateLocation: boolean = false;

  public selectedMap: string = 'osrm';

  public disableLocation: boolean = true;

  //geofence
  public pickupRadiusCircle: any;
  public isLoctionMarked: boolean = false;
  public geofenceRadius: number;
  public markedlocations: any = [];
  public branchInformation: any = [];
  public isMultipleGeo: boolean = false;

  //radius error
  public isRadiusGreater: boolean = false;
  public radiusError: string = '';
  geofenceID: any;
  vehiclelistsBackup: any;
  viewOption: any;
  constructor(
    public api: ApiService,
    public swal: SweetAlert,
    public route: ActivatedRoute,
    public storage: StorageService,
    public router: Router,
    public ngZone: NgZone,
    private fb: FormBuilder) {
    this.orgID = this.storage.get('userInfo').orgID;
    this.route.paramMap.subscribe((params: any) => {
      this.geofenceID = params.params.geofenceID;
      if (params.params['view']) this.viewOption = params.params.view;
      console.log("view opt",this.viewOption)
    });
    let user = this.storage.get('userInfo');
    if (user && user.map) {
      this.selectedMap = user.map;
    }
    this.getBranchList()
  }
  get f(): { [key: string]: AbstractControl } {
    return this.editGeofenceForm.controls;
  }
  ngOnInit(): void {
    this.editBranchLoad();
    this.getGeofenceData();
    this.getListVehicle();
  }
  editBranchLoad() {
    this.editGeofenceForm = this.fb.group({
      branch: ['', [Validators.required]],
      radius: ['1', [Validators.required]],
      location: ['', [Validators.required]],
      title: ['', [Validators.required, Validators.pattern(/^([A-Za-z ])+(?:\.[a-zA-Z]+?)*$/)]],
      vehicles: ['', [Validators.required]],
      isEnable: ['true', [Validators.required]],
    });
    if (this.viewOption === 'view') {
      const controlNames = Object.keys(this.editGeofenceForm.controls);
  
      controlNames.forEach(controlName => {
        const control = this.editGeofenceForm.get(controlName);
        if (control) {
          control.disable();
        }
      });
  
      this.editGeofenceForm.get('title')?.disable();
      this.editGeofenceForm.get('radius')?.disable();
    }
  }

  formatName() {
    let title = this.editGeofenceForm.value.title.replace(/ {2,}/g, ' ').trim();
    this.editGeofenceForm.patchValue({
      title: title
    })
  }


  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        if (res.data && res.data.length > 0) {
          res.data.filter((e) => {
            let option = { name: e.branchName, value: e.branchID };
            this.branchInformation.push(option);
          });
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  getGeofenceData() {
    const obj = {
      geofenceID: this.geofenceID
    };
    this.api.transportManagerGeofenceList(obj).then((res: any) => {
      if (res.status == 'success') {
        let data = res.data.find((e) => e.geofenceID == this.geofenceID);
        data['editTrue'] = 'noEdit';
        this.markedlocations.push(data);
        this.setValueEditGeofencehForm(data)
        // this.tableDataProcess(res.data)
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  getListVehicle() {
    const obj = {
    };
    this.api.transportManagerVehicleList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.vehiclelists = res.data;
        this.vehiclelistsBackup = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  setValueEditGeofencehForm(data) {
    this.geofenceRadius = data.radius;
    this.editGeofenceForm = this.fb.group({
      branch: [data?.branch ? data?.branch : '', [Validators.required]],
      radius: [data?.radius ? data?.radius : '', [Validators.required]],
      location: [data?.location ? data?.location?.name : '', [Validators.required]],
      title: [data?.title ? data?.title : '', [Validators.required, Validators.pattern(/^([A-Za-z0-9 ])+(?:\.[a-zA-Z0-9]+?)*$/)]],
      vehicles: [data?.vehicles ? data.vehicles : [], [Validators.required]],
      isEnable: [data?.isEnable +'', [Validators.required]],
    });
    this.locationData = { ...data?.location };
  }

  getLocation(obj) {
    this.branchLocation = { ...obj };
    this.fieldChange(this.branchLocation, 'location', 'location');
  }

  /* checking error in fields*/
  public checkError = (controlName: string, errorName: string) => {
    return this.editGeofenceForm.controls[controlName].hasError(errorName);
  }
  /* update unique field*/
  fieldChange(e: any, type, field) {
    if (type == 'text' || type == 'textarea') {
      this.updateField(field, e.target.value);
    }
    if (type == 'date' || type == 'dropdown') {
      if (field == 'isEnable') {
        this.updateField(field, convertStringToBoolean(e.value));
        function convertStringToBoolean(value: string) {
          return value === 'true';
        }
      } else {
        this.updateField(field, e.value);
      }
    }
    if (type == 'location') {
      this.updateField(field, e);
    }
    if (type == 'number') {
      this.updateField(field, +e.target.value);
    }
    // if (type == 'checkbox') {
    //   this.updateField(field, e.checked);
    // }
  }
  updateField(field, value) {
    if (this.updateValues.length > 0) {
      let filterUpdate = this.updateValues.filter((e) => e.field != field);
      let obj = { field: field, value: value, };
      this.updateValues = [
        ...filterUpdate,
        obj,
      ]

    }
    else {
      let obj = { field: field, value: value, };
      this.updateValues.push(obj);
    }
  }
  radiusValidation(e) {
    // this.fieldChange(e, 'number', 'radius');
    this.geofenceRadius = this.editGeofenceForm.value.radius;
    let radiusField = document.getElementById('radiusField');
    if (this.editGeofenceForm.value.radius <= 25 && this.editGeofenceForm.value.radius > 0 && this.editGeofenceForm.value.radius != null) {
      this.isRadiusGreater = false;
      radiusField.classList.remove('mat-form-field-invalid');
      radiusField.classList.remove('ng-invalid');
      radiusField.classList.add('ng-valid');
      this.radiusError = '';
    } else if (this.editGeofenceForm.value.radius == null) {
      radiusField.classList.add('mat-form-field-invalid');
      radiusField.classList.add('ng-invalid');
      radiusField.classList.remove('ng-valid');
      this.isRadiusGreater = false;
      this.radiusError = '';
    } else if (this.editGeofenceForm.value.radius == 0) {
      radiusField.classList.add('mat-form-field-invalid');
      radiusField.classList.add('ng-invalid');
      radiusField.classList.remove('ng-valid');
      this.radiusError = 'Radius must be above 0KM';
      this.isRadiusGreater = true;
    } else {
      radiusField.classList.add('mat-form-field-invalid');
      radiusField.classList.add('ng-invalid');
      radiusField.classList.remove('ng-valid');
      this.radiusError = 'Radius limits upto 25KM';
      this.isRadiusGreater = true;
    }
  }
  getSelectedLocation(obj) {
    this.branchLocation = { ...obj };
    if (this.branchLocation['condition'] == '') {
      this.fieldChange(this.branchLocation, 'location', 'location');
    }
    if (this.branchLocation && this.branchLocation['name'] && this.branchLocation['name'] != '') {
      this.editGeofenceForm.patchValue({
        location: this.branchLocation['name']
      })
    }
  }
  /* Delete Data*/
  delete() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',//'#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteBranch();
        // Swal.fire(
        //   'Deleted!',
        //   'Your file has been deleted.',
        //   'success'
        // );
      }
    });
  }
  deleteBranch() {
    const obj = {
      orgID: this.orgID,
      branchID: this.branchID
    };
    this.api.transportManagerBranchDelete(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 20000);
        this.router.navigate(['/organization/transport-manager/information/orgInfo/geofence/view-geofence']);
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 20000);
      }
    });
  }
  /* Cancel Edit*/
  cancel() {
    this.router.navigate(['/organization/transport-manager/information/orgInfo/geofence/view-geofence']);
  }
  /* Submit Data*/
  onSubmit() {

    this.formSubmit = true;
    this.editGeofenceFormSubmitted = true;
    if (this.selectedMap == 'google') {
      // this.radiusValidation();
    }
    if (this.updateValues && this.updateValues.length > 0 && (this.editGeofenceForm.valid && this.selectedMap != 'google' || this.editGeofenceForm.valid && this.selectedMap == 'google' && !this.isRadiusGreater)) {
      // const obj = this.editGeofenceForm.value;
      const obj = {}
      obj['geofenceID'] = this.geofenceID,
        obj['orgID'] = this.storage.get('userInfo').orgID,

        this.updateValues.filter((e) => {
          obj[e.field] = e.value;
        });
      this.api.transportManagerGeofenceUpdate(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.router.navigate(['/organization/transport-manager/information/orgInfo/geofence/view-geofence'])
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }
      }).catch((err) => {
        console.log(err);
      });
    } else {
      if (!this.editGeofenceForm.valid) {
        this.editGeofenceForm.markAllAsTouched();
      }
      if (this.updateValues.length == 0) {
        this.swal.swalFunction('warning', "warning", "Please make any change and update!", 6000);
      }
    }
  }

  getVehicleResult(value, event) {
    //  this.selectedVehicle = value;
  }
}